import * as React from 'react';
import GridContainer from "../GenericComponents/Grids/GridContainer";
import {createBreadCrumbBasedOnPage} from "../../Utils/HelperFunctions";
import * as actionTypes from "../../store/action";
import {connect} from "react-redux";

interface TsrCostAllocationProps {
    setBreadCrumbPath: (breadCrumbPath:BreadCrumb[]) => void;
}

interface TsrCostAllocationState {
}

class TsrCostAllocation extends React.Component<TsrCostAllocationProps,TsrCostAllocationState> {

    constructor(props: TsrCostAllocationProps) {
        super(props);
    }

    componentDidMount(): void {
        this.props.setBreadCrumbPath(createBreadCrumbBasedOnPage(window.location.pathname.split('/').filter(x => x)));
    }

    render() {
        return (
            <GridContainer
                getGridDataUrl={'/api/auth/viewGridData/oasisTsrCostAlloc'}
                addRecordUrl={'/api/auth/saveGridRecord/oasisTsrCostAlloc'}
                editRecordUrl={'/api/auth/editGridRecord/oasisTsrCostAlloc'}
                deleteRecordUrl={'/api/auth/removeGridRecord/oasisTsrCostAlloc'}
                gridPaginated={true}
                formEditing={true}
                showUtilityColumns={true}
                exportLink={'viewGridData/oasisTsr/tsrCostAllocation'}
                gridTitle={'View TSR Cost Allocation'}
                gridId={'TsrCostAllocationGrid'}
                typeForSuperClass={'oasisTsrCostAlloc'}
            />
        );
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        setBreadCrumbPath: (breadCrumbPath:BreadCrumb[]) => dispatch(
            {type: actionTypes.SET_BREADCRUMB_PATH, payload: breadCrumbPath})
    }
};

export default connect(null, mapDispatchToProps)(TsrCostAllocation);